<template>
    <div>




        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <h3 class="subtitle is-3  has-text-grey">Result PCR Management</h3>
                </div>
                <div class="level-item">
                   <b-button
                           type="is-success"
                           icon-right="refresh"
                           @click="loadResultAval"
                   />
                </div>
            </div>
            <div class="level-right">

            </div>
        </nav>



        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>



        <b-tabs v-model="tabNewRes" @input="prepareDataRes" >
            <b-tab-item label="List of result" icon="format-list-bulleted">


                <b-table
                        :data="dataResultSearch"
                        bordered
                        striped
                        narrowed
                        hoverable
                        focusable
                        mobile-cards
                >


                    <b-table-column   label="No"  v-slot="props">
                        {{ props.row.no }}
                    </b-table-column>
                    <b-table-column   label="Result Available"  v-slot="props">

                        <b-field >

                            <p class="control"  v-for="datResult in props.row.data_res.id" :key="datResult" >
                                <span class="button is-static" expanded>{{datResult}}</span>
                            </p>


                        </b-field>



                    </b-table-column>
                    <b-table-column   label="#"  v-slot="props">
                        <b-button type="is-info" @click="select(props.row.id,props.row.data_res)">Select</b-button>
                    </b-table-column>

                </b-table>
            </b-tab-item>

            <b-tab-item label="Add New Result Template"  icon="folder-plus-outline">
                <div class="container">
                    <nav class="level is-mobile">
                        <div class="level-left">

                        </div>
                        <div class="level-right">

                            <div class="level-item">
                                <b-button type="is-success"  @click="addNewDataRes" icon-right="plus" />
                            </div>
                        </div>
                    </nav>


                    <b-field  v-for="(dataNew,index) in dataAddNewArr" :key="dataNew.id">
                        <template #label>
                            {{index+1}}
                        </template>
                        <b-input  v-model = dataNew.val placeholder="Negative" expanded/>
                        <b-button type="is-danger"  icon-right="delete"  @click="deleteDataNew(dataNew.id)"/>
                    </b-field>



                    <nav class="level is-mobile">
                        <div class="level-left">

                        </div>
                        <div class="level-right">

                            <div class="level-item">
                                <b-button type="is-success"
                                          icon-right="cloud-upload"
                                          :disabled="dataAddNewArr.length===0"
                                          @click="saveTemplateResult">
                                    Save Template Result
                                </b-button>

                            </div>
                        </div>
                    </nav>


                </div>
            </b-tab-item>
        </b-tabs>

    </div>
</template>

<script>
    import axios from "axios";
    import {getBaseURLforBackEnd,getConfigAxios,genUUID}  from '@/utils.js'
    import { mapState } from "vuex";


    export default {
        name: "ManageLabPCRResultMaster",
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            saveTemplateResult(){
                // console.log(JSON.stringify(this.dataAddNewArr))
                var testFail = false
                var tmpArr = []
                for(var i =0;i<this.dataAddNewArr.length;i++){
                    if(this.dataAddNewArr[i].val === ""){
                        testFail = true
                        break;
                    }else{
                        tmpArr.push(this.dataAddNewArr[i].val)
                    }
                }
                //************************************************
                if(testFail){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Some data hak blank , please check!',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }else{
                     const datTo = {
                                      "mode" : 1, // 1 or 2  1 === new insert , 2 === update
                                      "id_edit": null , // id to edit if  update
                                      "dat" : {"id": tmpArr }
                                     }
                     // console.log(JSON.stringify(datTo))
                    const vm = this
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/insertorupdateresultpcrmaster`,datTo,getConfigAxios())
                    .then((res)=>{
                        vm.$buefy.toast.open({
                            duration: 1200,
                            message: `${res.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                        vm.prepareDataRes()
                        vm.tabNewRes = 0
                        vm.loadResultAval()
                    })
                    .catch((err)=>{
                        vm.$buefy.toast.open({
                            duration: 1200,
                            message: `${err.response}`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                    })
                }
            },
            addNewDataRes(){
                this.dataAddNewArr.push({"id": genUUID(5) ,"val" :  ""})
            },
            deleteDataNew(_id){
              const member =  this.dataAddNewArr.find(dat=>{
                    return dat.id === _id
                })
                const memberIndex = this.dataAddNewArr.indexOf(member)
                this.dataAddNewArr.splice(memberIndex,1)
            },
            prepareDataRes(){
                // console.log( this.tabNewRes )
                if(this.tabNewRes === 1){
                    this.dataAddNewArr = [] // {"id": "" , "val" :  ""}
                    for(var i =0;i<=1;i++){
                        this.dataAddNewArr.push({"id": genUUID(5) ,"val" :  ""})
                    }

                }
            },
            select(_id,dataRes){
                const tmp = {
                             "result_type":_id,
                             "result_dat_aval": dataRes
                             }
               // console.log(_id,dataRes)
                this.$emit('returnDatFromManageLabPCRResultMasterWantToChange',tmp)
            },
            loadResultAval(){
                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofresultpcrmaster`, getConfigAxios())
                    .then((res) => {
                        vm.dataResultSearch = res.data
                        vm.isFullScreenLoading = false
                    })
                    .finally(() => {
                        vm.isDataResultSearchLoading = false
                    })
            }
        },
        props:{
            isShowing : Boolean
        },
        data(){
            return{
                isFullScreenLoading : false,
                dataResultSearch : [],


                tabNewRes : 0 ,
                // dataAddNew : {"id": [this.dataAddNewArr.val , ...] },
                dataAddNewArr:[], // {"id": "" : "val" :  ""}
            }
        },
        watch :{
            isShowing:{
               immediate: true,
               handler: function (val) {
                   if(val){
                       this.loadResultAval()
                   }

               }
            }
        }
    }
</script>

<style scoped>

</style>